import React, { useRef } from "react";
import { TOOL_TEMPLATE } from "../constant/common";
import { useCompanySettings, useTemplateSetting } from "../hooks/useCompanySettings";
import { i18n } from "@euroland/libs";
import { Tooltip } from "@euroland/react-tooltip";
import { useSelector } from "react-redux";
import { linkDownloadSelector } from "../store/slice/trade";

/**
 * @typedef {() => JSX.Element | nul } IButtonWillRender function because we want lazy init component
 */
const appSettings = window.appSettings;

const DownloadButton = () => {
  const template = useTemplateSetting();
  const settings = useCompanySettings();
  const ref = useRef();

  const isPreviewParam = appSettings.isPreview ? "&isPreview" : "";
  const downloadLink = useSelector(linkDownloadSelector) + isPreviewParam;
  if (!settings.enableExcelDownload) return null;

  /** @type { IButtonWillRender } */
  let buttonWillRender = null;

  switch (template) {
    case TOOL_TEMPLATE.victor:
      buttonWillRender = () => (
        <a rel="noreferrer" href={downloadLink} target="_self">
          <span className="fs-icon fs-excel cursor-pointer icon-container"></span>
          <span className="download-button--title">{i18n.translate("excel")}</span>
        </a>
      );
      break;
    case TOOL_TEMPLATE.quadrata:
      buttonWillRender = () => (
        <Tooltip right={!appSettings.isRtl} label={i18n.translate("downloadButtonQuadrata")}>
          <a rel="noreferrer" href={downloadLink} target="_self">
            <span className="fs-icon fs-excel cursor-pointer"></span>
          </a>
        </Tooltip>
      );
      break;
    default:
      // we don't render any thing if template don't match
      return null;
  }
  return <div className="download-button">{settings.enableExcelDownload && buttonWillRender()}</div>;
};

export default DownloadButton;
